<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6" id="title-card-authorization">
            <q-icon :name="'img:' + require('@/assets/img/rocket.svg')"></q-icon> Añadir acción
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <slot name="body">
            <HeaderPopUp/>

            <!--Linea de actuación-->
            <div class="row">
              <q-select
                label="Linea de actuación"
                class="input col-12 required"
                outlined
                :options="optionsLineasActuacion ? optionsLineasActuacion : 'No hay datos'"
                option-value="id"
                option-label="name"
                v-model="optionLineaActuacionSelected"
                :error="$v.optionLineaActuacionSelected.$error"
                @input="addLinea"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-select>
            </div>
            <div class="row">
              <div class="divChip" v-for="(linea, index) in arrayLineasActuacionAdded" :key="index">
                <div class="divTextChip">{{linea.name}} </div>
                <div><q-icon class="iconCancel cursor-pointer" size="sm" name="cancel" @click="removeLinea(linea.index)"></q-icon></div>
              </div>
            </div>
            <!--ACCIÓN-->
            <div class="divApartado">Acción</div>
            <!--Nombre-->
            <div class="row">
              <q-input
                outlined
                label="Nombre de la acción"
                class="col-12 required"
                v-model.trim="$v.nombre.$model"
                :error="$v.nombre.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-input>
            </div>
            <!--Descripción detallada-->
            <div class="row">
              <q-input
                type="textarea"
                label="Descripción detallada"
                outlined
                class="col-12 required"
                v-model.trim="$v.descripcion.$model"
                :error="$v.descripcion.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-input>
            </div>
            <!--Agente responsable-->
            <div class="row">
              <q-input
                outlined
                label="Agente responsable"
                class="col-12 required"
                v-model.trim="$v.agente.$model"
                :error="$v.agente.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-input>
            </div>
            <!--Agentes involucrados-->
            <div class="row">
              <q-input
                type="textarea"
                label="Agentes involucrados"
                outlined
                class="col-12 required"
                v-model.trim="$v.agentesInvolucrados.$model"
                :error="$v.agentesInvolucrados.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-input>
            </div>
            <!--caracter-->
            <div class="row">
              <q-select
                label="Carácter"
                class="input col-5 required"
                outlined
                :options="optionsCaracter ? optionsCaracter : 'No hay datos'"
                option-value="id"
                option-label="name"
                v-model="optionCaracterSelected"
                :error="$v.optionCaracterSelected.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-select>
            </div>

            <!--PLAZO-->
            <div class="divApartado">Plazo</div>
            <!--plazo-->
            <div class="row">
              <q-select
                label="Plazo"
                class="input col-3 required"
                outlined
                :options="optionsPlazo ? optionsPlazo : 'No hay datos'"
                option-value="id"
                option-label="name"
                v-model="optionPlazoSelected"
                :error="$v.optionPlazoSelected.$error"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-select>
            </div>

            <!--FASE DE LA ACCIÓN-->
            <div class="divApartado">Fase de la acción</div>

            <div class="row">
              <div class="divRadioButton col-10">
                <q-radio @input="changeRadio()" v-model="fase" val="PLANIFICADO" label="Planificada"></q-radio>
              </div>
              <div class="divRadioButton col-10">
                <q-radio @input="changeRadio()" class="itemRadio" v-model="fase" val="EN PROYECTO" label="En proyecto"></q-radio>
                <div class="divDataFase">
                  <q-input
                    class="required"
                    outlined
                    label="Fecha inicio prevista"
                    v-model="$v.proyectoFechaInicio.$model"
                    mask="date"
                    :error="$v.proyectoFechaInicio.$error"
                    :rules="[
                    'date',
                    (val) =>
                        validateFechaIni(proyectoFechaInicio, proyectoFechaFin) ||
                        'La fecha inicial no puede ser superior a la fecha final'
                        ]"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          ref="qDateProxy"
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date v-model="proyectoFechaInicio">
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Cerrar"
                                color="primary"
                                flat
                              ></q-btn>
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                    <template v-slot:error>Fecha no válida.</template>
                  </q-input>

                  <q-input
                    class="required"
                    outlined
                    label="Fecha finalización prevista"
                    v-model="$v.proyectoFechaFin.$model"
                    mask="date"
                    :error="$v.proyectoFechaFin.$error"
                    :rules="[
                    'date',
                    (val) =>
                        validateFechaFin(proyectoFechaInicio, proyectoFechaFin) ||
                        'La fecha final no puede ser inferior a la fecha inicial'
                    ]"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          ref="qDateProxy"
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date v-model="proyectoFechaFin">
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Cerrar"
                                color="primary"
                                flat
                              ></q-btn>
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                    <template v-slot:error> Fecha no válida.</template>
                  </q-input>
                </div>
              </div>
              <div class="divRadioButton col-10">
                <q-radio @input="changeRadio()" class="itemRadio" v-model="fase" val="EN EJECUCIÓN" label="En ejecución"></q-radio>
                <div class="divDataFase">
                  <q-input
                    class="required"
                    outlined
                    label="Fecha inicio real"
                    v-model="$v.ejecucionFechaInicio.$model"
                    mask="date"
                    :error="$v.ejecucionFechaInicio.$error"
                    :rules="[
                    'date',
                    (val) =>
                        validateFechaIni(ejecucionFechaInicio, ejecucionFechaFin) ||
                        'La fecha inicial no puede ser superior a la fecha final'
                        ]"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          ref="qDateProxy"
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date v-model="ejecucionFechaInicio">
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Cerrar"
                                color="primary"
                                flat
                              ></q-btn>
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                    <template v-slot:error>Fecha no válida.</template>
                  </q-input>

                  <q-input
                    class="required"
                    outlined
                    label="Fecha finalización prevista"
                    v-model="$v.ejecucionFechaFin.$model"
                    mask="date"
                    :error="$v.ejecucionFechaFin.$error"
                    :rules="[
                    'date',
                    (val) =>
                        validateFechaFin(ejecucionFechaInicio, ejecucionFechaFin) ||
                        'La fecha final no puede ser inferior a la fecha inicial'
                    ]"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          ref="qDateProxy"
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date v-model="ejecucionFechaFin">
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Cerrar"
                                color="primary"
                                flat
                              ></q-btn>
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                    <template v-slot:error> Fecha no válida.</template>
                  </q-input>

                  <q-input
                    label="Porcentaje realizado"
                    v-model.number="$v.procentageRealizado.$model"
                    type="number"
                    outlined
                    class="col- required"
                    :error="$v.procentageRealizado.$error"
                  >
                  <template v-slot:error>
                    <span>Dato obligatorio.</span>
                  </template>
                </q-input>
                </div>
              </div>
              <div class="divRadioButton col-10">
                <q-radio @input="changeRadio()" class="itemRadio" v-model="fase" val="FINALIZADA" label="Finalizada"></q-radio>
                <div class="divDataFase">
                  <q-input
                    class="required"
                    outlined
                    label="Fecha inicio real"
                    v-model="$v.finalizadaFechaInicio.$model"
                    mask="date"
                    :error="$v.finalizadaFechaInicio.$error"
                    :rules="[
                    'date',
                    (val) =>
                        validateFechaIni(finalizadaFechaInicio, finalizadaFechaFin) ||
                        'La fecha inicial no puede ser superior a la fecha final'
                        ]"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          ref="qDateProxy"
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date v-model="finalizadaFechaInicio">
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Cerrar"
                                color="primary"
                                flat
                              ></q-btn>
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                    <template v-slot:error>Fecha no válida.</template>
                  </q-input>

                  <q-input
                    class="required"
                    outlined
                    label="Fecha finalización real"
                    v-model="$v.finalizadaFechaFin.$model"
                    mask="date"
                    :error="$v.finalizadaFechaFin.$error"
                    :rules="[
                    'date',
                    (val) =>
                        validateFechaIni(finalizadaFechaInicio, finalizadaFechaFin) ||
                        'La fecha inicial no puede ser superior a la fecha final'
                        ]"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          ref="qDateProxy"
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date v-model="finalizadaFechaFin">
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Cerrar"
                                color="primary"
                                flat
                              ></q-btn>
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                    <template v-slot:error>Fecha no válida.</template>
                  </q-input>
                </div>
              </div>
            </div>

            <!--PRESUPUESTO-->
            <q-form ref='form'>
            <div class="divApartado">Presupuesto</div>
            <!--presupuesto total--><!--contribución del sector privado-->
            <div class="row divPresupuesto">
              <q-input
                label="Presupuesto total"
                v-model.number="$v.presupuestoTotal.$model"
                outlined
                class="col-2 required"
                type="number"
                :error="$v.presupuestoTotal.$error"
                :rules="[(val) =>validateNumberWith2Decimals(val) || 'Número incorrecto, máx 2 decimales.']"
              >
                <template v-slot:error>
                  <span>Dato obligatorio.</span>
                </template>
              </q-input>
              <q-input
                label="Contribución del sector privado"
                v-model.number="contribucion"
                type="number"
                outlined
                 class="col-4"
                :rules="[(val) =>validateNumberWith2Decimals(val) || 'Número incorrecto, máx 2 decimales.']"
              >
              </q-input>
            </div>

            <!--Presupuesto anualizado-->
            <div class="divSubapartado">Presupuesto anualizado</div>
            <div class="row divPresupuestoAnual">
                <q-input
                  v-for="(presupuesto, i) in presupuestos"
                  :label="presupuesto.name"
                  v-bind:key="i"
                  v-model.number="presupuesto.value"
                  type="number"
                  outlined
                  class="col-2"
                  :rules="[(val) =>validateNumberWith2Decimals(val) || 'Número incorrecto, máx 2 decimales.']"
                ></q-input>
            </div>
          </q-form>
            <!--Otras observaciones-->
            <div class="row">
              <q-input
                v-model="observaciones"
                type="textarea"
                label="Otras observaciones"
                outlined
                class="col-12"
              ></q-input>
            </div>
          </slot>
        </q-card-section>

        <q-card-actions align="right" class="text-primary container-actions">
          <q-btn
            class="bSecondary"
            flat
            label="Cancelar"
            @click="cancel()"
          />
          <q-btn
            :label="Object.keys(this.currentAccion).length !== 0? 'GUARDAR ACCIÓN': 'AÑADIR NUEVA ACCIÓN'"
            class="bPrincipal"
            padding="xs lg"
            @click="save()"
            :disabled="isValidFrom()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
     <DialogDelete
      v-model="showDialogDelete"
      dataCy="delete-indicador"
      :showIcon="false"
      :txtContainer="
        `Si cancela se perderán los cambios no guardados ¿Desea continuar?`
      "
      labelDelete="SÍ, CONTINUAR"
      @save="cancelEdit()"
    />
  </div>
</template>

<script>
import { QDialog, QIcon, QRadio, QPopupProxy, QForm } from 'quasar';
import * as types from '@/storeModules/NGUD/types';
import Validation from '@/components/shared/mixins/Validation.js';
import { required } from 'vuelidate/lib/validators';
import Message from '@/components/shared/mixins/Message.js';
import moment from 'moment';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import HeaderPopUp from '@/components/PlanAccion/components/HeaderPopUp.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    QDialog,
    QIcon,
    QRadio,
    QPopupProxy,
    DialogDelete,
    HeaderPopUp,
    QForm
  },
  mixins: [Message, Validation],
  props: {
    value: {
      required: true
    },
    currentAccion: Object
  },
  validations: {
    nombre: { required },
    descripcion: { required },
    agente: { required },
    agentesInvolucrados: { required },
    optionCaracterSelected: { required },
    optionPlazoSelected: { required },
    optionLineaActuacionSelected: { required },
    proyectoFechaInicio: { required },
    proyectoFechaFin: { required },
    ejecucionFechaInicio: { required },
    ejecucionFechaFin: { required },
    procentageRealizado: { required },
    finalizadaFechaInicio: { required },
    finalizadaFechaFin: { required },
    presupuestoTotal: { required }
  },
  computed: {
    ...mapGetters({
      objetivoEspecifico: 'NGUD/objetivoEspecifico'
    })
  },
  data () {
    return {
      valueLocal: this.value,
      optionLineaActuacionSelected: null,
      optionsLineasActuacion: [],
      optionsCaracter: [],
      optionsPlazo: [],
      newActuacion: {},
      ArraylineasActuación: [],
      nombre: '',
      descripcion: '',
      agente: '',
      agentesInvolucrados: '',
      optionCaracterSelected: [],
      optionPlazoSelected: [],
      fase: 'PLANIFICADO',
      proyectoFechaInicio: null,
      proyectoFechaFin: null,
      ejecucionFechaInicio: null,
      ejecucionFechaFin: null,
      procentageRealizado: null,
      finalizadaFechaFin: null,
      finalizadaFechaInicio: null,
      presupuestoTotal: null,
      contribucion: 0,
      presupuestos: [],
      observaciones: '',
      arrayLineasActuacionAdded: [],
      showDialogDelete: false
    };
  },
  created () {
    this.clean();
    // lineas de actuación
    this.$store
      .dispatch(types.ACTION_GET_OBJETIVOS_ESPECIFICOS_LINEAS_ACTUACION, { idObjetivo: this.objetivoEspecifico.id })
      .then(response => {
        this.optionsLineasActuacion = response.data;
      });
    // plazo
    this.$store
      .dispatch(types.ACTION_GET_PLAZOS_INDICADORAUE)
      .then(response => {
        this.optionsPlazo = response.data.plazos;
      });
    // carácter
    this.$store
      .dispatch(types.ACTION_GET_CARACTERES_INDICADORAUE)
      .then(response => {
        this.optionsCaracter = response.data.caracteres;
      });
  },
  watch: {
    value: {
      handler: function () {
        this.clean();
        for (let i = 1; i < 12; i++) {
          this.presupuestos.push({ name: 'Presupuesto ' + i, value: 0 });
        }
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
        if (Object.keys(this.currentAccion).length !== 0) this.fillCurrentAccion();
      },
      immediate: true
    }
  },
  methods: {
    cancel () {
      this.showDialogDelete = true;
    },
    cancelEdit () {
      this.showDialogDelete = false;
      this.clean();
      this.$emit('input', false);
      this.$v.$reset();
    },
    clean () {
      this.arrayLineasActuacionAdded = [];
      this.nombre = '';
      this.descripcion = '';
      this.agente = '';
      this.agentesInvolucrados = '';
      this.optionCaracterSelected = [];
      this.optionPlazoSelected = [];
      this.proyectoFechaInicio = null;
      this.proyectoFechaFin = null;
      this.ejecucionFechaInicio = null;
      this.ejecucionFechaFin = null;
      this.procentageRealizado = null;
      this.finalizadaFechaFin = null;
      this.finalizadaFechaInicio = null;
      this.presupuestoTotal = null;
      this.contribucion = 0;
      this.presupuestos = [];
      this.observaciones = '';
      this.optionLineaActuacionSelected = null;
    },
    fillCurrentAccion () {
      this.nombre = this.currentAccion.name;
      this.descripcion = this.currentAccion.descripcion;
      this.agente = this.currentAccion.agenteResponsable;
      this.agentesInvolucrados = this.currentAccion.agentesInvolucrados;
      this.optionCaracterSelected = this.currentAccion.caracter;
      this.optionPlazoSelected = this.currentAccion.plazo;
      this.presupuestoTotal = this.currentAccion.presupuestoTotal;
      this.contribucion = this.currentAccion.presupuestoContribucion;
      this.presupuestos = this.currentAccion.presupuestos;
      this.observaciones = this.currentAccion.observaciones;
      this.arrayLineasActuacionAdded = this.currentAccion.lineasDeActuacion;
      this.fase = this.currentAccion.fase.label;
      this.fillFaseEdited();
    },
    checkFrom () {
      return !this.$v.optionLineaActuacionSelected.$error &&
      !this.$v.nombre.$error &&
      !this.$v.descripcion.$error &&
      !this.$v.agente.$error &&
      !this.$v.agentesInvolucrados.$error &&
      !this.$v.optionCaracterSelected.$error &&
      !this.$v.optionPlazoSelected.$error &&
      !this.$v.presupuestoTotal.$error &&
      !this.$v.proyectoFechaInicio.$error &&
      !this.$v.proyectoFechaFin.$error &&
      !this.$v.ejecucionFechaInicio.$error &&
      !this.$v.ejecucionFechaFin.$error &&
      !this.$v.procentageRealizado.$error &&
      !this.$v.finalizadaFechaInicio.$error &&
      !this.$v.finalizadaFechaFin.$error;
    },
    checkFase () {
      if (this.fase === 'EN PROYECTO') {
        return (this.proyectoFechaInicio !== '' && this.proyectoFechaInicio !== null) &&
        (this.proyectoFechaFin !== '' && this.proyectoFechaFin !== null);
      }
      if (this.fase === 'EN EJECUCIÓN') {
        return (this.ejecucionFechaInicio !== '' && this.ejecucionFechaInicio !== null) &&
        (this.ejecucionFechaFin !== '' && this.ejecucionFechaFin !== null) &&
        (this.procentageRealizado !== '' && this.procentageRealizado !== null);
      }
      if (this.fase === 'FINALIZADA') {
        return (this.finalizadaFechaInicio !== '' && this.finalizadaFechaInicio !== null) &&
        (this.finalizadaFechaFin !== '' && this.finalizadaFechaFin !== null);
      }
      if (this.fase === 'PLANIFICADO') {
        return true;
      }
    },
    checkRequired () {
      return (this.arrayLineasActuacionAdded.length > 0) &&
      (this.nombre !== null && this.nombre !== '') &&
      (this.descripcion !== null && this.descripcion !== '') &&
      (this.agente !== null && this.agente !== '') &&
      (this.agentesInvolucrados !== null && this.agentesInvolucrados !== '') &&
      this.optionCaracterSelected.length !== 0 &&
      this.optionPlazoSelected.length !== 0 &&
      this.presupuestoTotal !== null &&
      (this.fase !== null && this.checkFase());
    },
    isValidFrom () {
      return !this.checkRequired() || !this.checkFrom();
    },
    save () {
      if (this.arrayLineasActuacionAdded.length <= 0) {
        this.$v.optionLineaActuacionSelected.$touch();
      }
      this.$v.nombre.$touch();
      this.$v.descripcion.$touch();
      this.$v.agente.$touch();
      this.$v.agentesInvolucrados.$touch();
      this.$v.optionCaracterSelected.$touch();
      this.$v.optionPlazoSelected.$touch();
      this.$v.presupuestoTotal.$touch();
      if (this.fase === 'EN PROYECTO') {
        this.$v.proyectoFechaInicio.$touch();
        this.$v.proyectoFechaFin.$touch();
      }
      if (this.fase === 'EN EJECUCIÓN') {
        this.$v.ejecucionFechaInicio.$touch();
        this.$v.ejecucionFechaFin.$touch();
        this.$v.procentageRealizado.$touch();
      }
      if (this.fase === 'FINALIZADA') {
        this.$v.finalizadaFechaFin.$touch();
        this.$v.finalizadaFechaInicio.$touch();
      }
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.checkFrom()) {
            this.newActuacion = {
              lineasDeActuacion: this.arrayLineasActuacionAdded,
              name: this.nombre,
              descripcion: this.descripcion,
              agenteResponsable: this.agente,
              agentesInvolucrados: this.agentesInvolucrados,
              caracter: this.optionCaracterSelected,
              plazo: this.optionPlazoSelected,
              presupuestoTotal: this.presupuestoTotal,
              observaciones: this.observaciones,
              fase: this.fillFase(),
              presupuestos: this.presupuestos,
              presupuestoContribucion: this.contribucion,
              position: Object.keys(this.currentAccion).length !== 0 ? this.currentAccion.position : null,
              id: Object.keys(this.currentAccion).length !== 0 ? this.currentAccion.id : null
            };
            this.$v.$reset();
            this.$emit('input', false);
            this.$eventHub.$emit('saveNewAccion', this.newActuacion);
          }
        }
      });
    },
    fillFase () {
      switch (this.fase) {
        case 'EN PROYECTO':
          return {
            label: 'EN PROYECTO',
            fechaInicioPrevista: moment(new Date(this.proyectoFechaInicio)).format('YYYY-MM-DD'),
            fechaFinPrevista: moment(new Date(this.proyectoFechaFin)).format('YYYY-MM-DD'),
            fechaInicioReal: null,
            fechaFinReal: null,
            porcentaje: null
          };
        case 'EN EJECUCIÓN':
          return {
            label: 'EN EJECUCIÓN',
            fechaInicioPrevista: null,
            fechaFinPrevista: moment(new Date(this.ejecucionFechaFin)).format('YYYY-MM-DD'),
            fechaInicioReal: moment(new Date(this.ejecucionFechaInicio)).format('YYYY-MM-DD'),
            fechaFinReal: null,
            porcentaje: this.procentageRealizado
          };
        case 'FINALIZADA':
          return {
            label: 'FINALIZADA',
            fechaInicioPrevista: null,
            fechaFinPrevista: null,
            fechaInicioReal: moment(new Date(this.finalizadaFechaInicio)).format('YYYY-MM-DD'),
            fechaFinReal: moment(new Date(this.finalizadaFechaFin)).format('YYYY-MM-DD'),
            porcentaje: null
          };
        case 'PLANIFICADO':
          return {
            label: 'PLANIFICADO',
            fechaInicioPrevista: null,
            fechaFinPrevista: null,
            fechaInicioReal: null,
            fechaFinReal: null,
            porcentaje: null
          };
      }
    },
    fillFaseEdited () {
      switch (this.currentAccion.fase.label) {
        case 'EN PROYECTO':
          let fechaInicioPrevista = this.currentAccion.fase.fechaInicioPrevista.split('T');
          let fechaFinPrevistaProyecto = this.currentAccion.fase.fechaFinPrevista.split('T');
          this.proyectoFechaInicio = moment(fechaInicioPrevista[0]).format('YYYY/MM/DD');
          this.proyectoFechaFin = moment(fechaFinPrevistaProyecto[0]).format('YYYY/MM/DD');
          break;
        case 'EN EJECUCIÓN':
          let fechaFinPrevista = this.currentAccion.fase.fechaFinPrevista.split('T');
          let fechaInicioReal = this.currentAccion.fase.fechaInicioReal.split('T');
          this.ejecucionFechaFin = moment(fechaFinPrevista[0]).format('YYYY/MM/DD');
          this.ejecucionFechaInicio = moment(fechaInicioReal[0]).format('YYYY/MM/DD');
          this.procentageRealizado = this.currentAccion.fase.porcentaje;
          break;
        case 'FINALIZADA':
          let fechaFinReal = this.currentAccion.fase.fechaFinReal.split('T');
          let fechaInicioRealFinalizada = this.currentAccion.fase.fechaInicioReal.split('T');
          this.finalizadaFechaFin = moment(fechaFinReal[0]).format('YYYY/MM/DD');
          this.finalizadaFechaInicio = moment(fechaInicioRealFinalizada[0]).format('YYYY/MM/DD');
          break;
      }
    },
    addLinea () {
      let newName = this.optionLineaActuacionSelected.name;
      let repeated = false;
      this.arrayLineasActuacionAdded.forEach(linea => {
        if (linea.name === newName) {
          this.showError('La linea de actuación ya está añadida, no se puede volver a añadir.');
          repeated = true;
        }
      });

      if (repeated === false) {
        this.arrayLineasActuacionAdded.push(this.optionLineaActuacionSelected);
      }
      this.optionLineaActuacionSelected = null;
      this.$v.optionLineaActuacionSelected.$reset();
    },
    removeLinea (index) {
      this.arrayLineasActuacionAdded.splice(index, 1);
      this.optionLineaActuacionSelected = null;
      if (this.arrayLineasActuacionAdded.length <= 0) {
        this.$v.optionLineaActuacionSelected.$touch();
      }
    },
    changeRadio () {
      switch (this.fase) {
        case 'EN PROYECTO':
          this.$v.ejecucionFechaInicio.$reset();
          this.$v.ejecucionFechaFin.$reset();
          this.$v.procentageRealizado.$reset();
          this.$v.finalizadaFechaFin.$reset();
          this.$v.finalizadaFechaInicio.$reset();
          break;
        case 'EN EJECUCIÓN':
          this.$v.proyectoFechaInicio.$reset();
          this.$v.proyectoFechaFin.$reset();
          this.$v.finalizadaFechaFin.$reset();
          this.$v.finalizadaFechaInicio.$reset();
          break;
        case 'FINALIZADA':
          this.$v.proyectoFechaInicio.$reset();
          this.$v.proyectoFechaFin.$reset();
          this.$v.ejecucionFechaInicio.$reset();
          this.$v.ejecucionFechaFin.$reset();
          this.$v.procentageRealizado.$reset();
          break;
        case 'PLANIFICADO':
          this.$v.proyectoFechaInicio.$reset();
          this.$v.proyectoFechaFin.$reset();
          this.$v.ejecucionFechaInicio.$reset();
          this.$v.ejecucionFechaFin.$reset();
          this.$v.procentageRealizado.$reset();
          this.$v.finalizadaFechaFin.$reset();
          this.$v.finalizadaFechaInicio.$reset();
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-authorization {
  min-width: 90%;
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $azulcabecera;
      display: flex;
      align-items: center;
    }
  }
  .container-actions {
    padding-top: 15px;
  }
  .container-auth {
    padding-top: 20px;
    padding-bottom: 25px;
    .title-option {
      font-family: DINPro;
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #5c5c5c;
      padding-bottom: 20px;
    }
  }
  &::v-deep {
    .q-field--standard .q-field__control:before {
      border-bottom-color: rgba(89, 89, 89, 0.5) !important;
    }
  }
}
.q-dialog__inner {
  div::v-deep {
    border-radius: 12px !important;
  }
  .fase {
    padding-right: 5px;
  }
  .periodo {
    padding-left: 5px;
  }
  .divChip{
    color: #042857 !important;
    font-family: DINPro;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.56px;
    border: solid 1px #979797;
    border-radius: 30px !important;
    padding: 10px;
    margin-bottom: 5px;
    align-items: center;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .iconCancel{
      color: grey;
      padding: 5px;
      margin: 0px;
    }
    .divTextChip{
      padding-left: 5px;
    }
  }
}
.q-card {
  padding-left: 40px;
  padding-right: 40px;
}
.divRadioButton{
  border-radius: 4px !important;
  border: solid 1px #a5a3a3;
  margin-bottom: 15px;
  padding-bottom: 5px;
  padding-top: 5px;
  padding-right: 5px;
  // width: 100%;
}
.divDataFase{
  float: right;
  display: flex;
  .q-field{
    padding-bottom: 0px;
    padding-right: 5px;
  }
}
.itemRadio{
  height: 100%;
}
.divApartado, .divSubapartado{
  margin-bottom: 10px;
  font-family: DINPro;
  font-size: 17px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.13px;
  color: #727272;
}
.divSubapartado{
  font-size: 14px;
}
.q-icon{
  margin-right: 10px;
}
.divPresupuestoAnual, .divPresupuesto{
  .q-input{
    padding-right: 5px;
    padding-top: 5px;
  }
}

</style>
